import { useMutation, useQueryClient } from "@tanstack/react-query"

import { useApiContext } from "@/hooks/api/use-api-context"

import { deleteHubspotIntegration, getHubspotAuthUri } from "./api"

export function useGetHubspotAuthUri() {
  const getContext = useApiContext()

  return useMutation({
    mutationFn: async () => {
      const context = await getContext()
      return getHubspotAuthUri(context)
    },
  })
}

export function useDeleteHubspotIntegration() {
  const getContext = useApiContext()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async () => {
      const context = await getContext()
      return deleteHubspotIntegration(context)
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["hubspot-integration"] })
    },
  })
}
